import { useEffect } from 'react';
import { clearSentryMonitoring, syncSentryMonitoring } from 'utils/analytics/sentryMonitoring';

interface SentryMonitoringOptions {
  ready: boolean;
  replayAllowed?: boolean;
  userId?: string | number | null;
  tenantId?: string | number | null;
  tenantName?: string | null;
  projectId?: string | number | null;
}

export function useSentryMonitoring({
  ready,
  replayAllowed = true,
  userId,
  tenantId,
  tenantName,
  projectId,
}: SentryMonitoringOptions): void {
  useEffect(() => {
    if (!ready) {
      // Route privacy applies before auth hydration finishes as well.
      if (!replayAllowed) clearSentryMonitoring();
      return;
    }

    const authenticated = userId != null;
    syncSentryMonitoring({
      replayAllowed,
      userId: authenticated ? String(userId) : null,
      tenantId: authenticated && tenantId != null ? String(tenantId) : null,
      tenantName: authenticated ? (tenantName ?? null) : null,
      projectId: authenticated && projectId != null ? String(projectId) : null,
    });
    // Unmount/Strict Mode cleanup is not logout. The auth action ends the session.
  }, [ready, replayAllowed, userId, tenantId, tenantName, projectId]);
}
